import { Entry } from '../Entry'

export function Entry20241211() {
  return (
    <Entry title="2024 Dec 11 - v3.9.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/14489/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
